import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import TooltipModal from "../Tooltip/TooltipModal";
import React from "react";
const AnswerTitle = ({
  children,
  sx,
  toolTip = null,
  showButton,
  buttonText,
  onClickButton = () => {},
  sxButton = {},
  icon = null,
}) => {
  const isMobileWidth = useMediaQuery("(max-width:900px)");
  const isMobileHeight = useMediaQuery("(max-height:650px)");
  const isMobile = isMobileWidth || isMobileHeight;

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        alignItems: "center",
        mb: 1,
        width: "100%",
      }}
    >
      <Typography
        variant={isMobile ? "h6" : "h5"}
        sx={{ width: "100%", ...sx }}
      >
        {children}
      </Typography>
      {toolTip && (
        <TooltipModal title={toolTip.title} content={toolTip.content} />
      )}

      {showButton && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            mb: 1,
            textDecoration: "underline",
          }}
        >
          {icon &&
            React.cloneElement(icon, {
              sx: {
                fontSize: "1.2rem",
              },
            })}
          <Typography
            variant="body2"
            onClick={onClickButton}
            sx={{
              ...sxButton,
              textDecoration: "underline",
              fontWeight: 700,
              whiteSpace: "nowrap",
              cursor: "pointer",
            }}
          >
            {buttonText}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default AnswerTitle;
